/**
 * Lightweight helpers for Google Tag Manager
 * - gtmPush: safely push events to dataLayer
 */

import { captureException } from '@sentry/react';

// Uses global DataLayerEvent type from src/types/global.d.ts

/** Ensure window.dataLayer exists and return it. Safe in browsers only. */
function ensureDataLayer(): Array<Record<string, unknown>> {
    if (typeof window === 'undefined') return [];
    if (!Array.isArray(window.dataLayer)) {
        window.dataLayer = [];
    }
    return window.dataLayer;
}

/** Push an event or object into the GTM dataLayer. No-op on server. */
export function gtmPush(data: DataLayerEvent | Record<string, unknown>): void {
    try {
        const dl = ensureDataLayer();
        dl.push(data as Record<string, unknown>);
    } catch (error) {
        // Swallow errors to avoid impacting app UX
        captureException(error);
    }
}
